import cn from "classnames";
import { useTranslation } from "react-i18next";

import {
  ESupportTicketPriority,
  ESupportTicketSource,
} from "../../aiTickets.types";

import styles from "./FiltersPopover.module.scss";

const PRIORITY_OPTIONS: { value: ESupportTicketPriority; label: string }[] = [
  { value: ESupportTicketPriority.Urgent, label: "Urgent" },
  { value: ESupportTicketPriority.Alert, label: "Alert" },
  { value: ESupportTicketPriority.FollowUp, label: "Follow up" },
  { value: ESupportTicketPriority.Reminder, label: "Reminder" },
  { value: ESupportTicketPriority.Low, label: "Information" },
];

const SOURCE_OPTIONS: { value: ESupportTicketSource; label: string }[] = [
  { value: ESupportTicketSource.WhatsApp, label: "WhatsApp" },
  { value: ESupportTicketSource.InAppSupport, label: "In-App Support" },
];

interface Props {
  priorities: ESupportTicketPriority[];
  sources: ESupportTicketSource[];
  onChangePriorities: (next: ESupportTicketPriority[]) => void;
  onChangeSources: (next: ESupportTicketSource[]) => void;
}

const toggle = <T,>(list: T[], value: T): T[] =>
  list.includes(value) ? list.filter((v) => v !== value) : [...list, value];

const TicketsFilterContent = ({
  priorities,
  sources,
  onChangePriorities,
  onChangeSources,
}: Props) => {
  const { t } = useTranslation();
  const hasFilters = priorities.length > 0 || sources.length > 0;

  return (
    <>
      <div className={styles.group}>
        <span className={styles.groupTitle}>{t("Type")}</span>
        <div className={styles.options}>
          {PRIORITY_OPTIONS.map((o) => (
            <button
              key={o.value}
              type="button"
              className={cn(styles.chip, {
                [styles.chipActive]: priorities.includes(o.value),
              })}
              onClick={() => onChangePriorities(toggle(priorities, o.value))}
            >
              {t(o.label)}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.group}>
        <span className={styles.groupTitle}>{t("Channel")}</span>
        <div className={styles.options}>
          {SOURCE_OPTIONS.map((o) => (
            <button
              key={o.value}
              type="button"
              className={cn(styles.chip, {
                [styles.chipActive]: sources.includes(o.value),
              })}
              onClick={() => onChangeSources(toggle(sources, o.value))}
            >
              {t(o.label)}
            </button>
          ))}
        </div>
      </div>

      {hasFilters && (
        <div className={styles.footer}>
          <button
            type="button"
            className={styles.clearBtn}
            onClick={() => {
              onChangePriorities([]);
              onChangeSources([]);
            }}
          >
            {t("Clear filters")}
          </button>
        </div>
      )}
    </>
  );
};

export default TicketsFilterContent;
